import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { ButtonListTiny } from "./ButtonListTiny";
import { OfflineStatus } from "../DocumentReader";
import { Strings } from "../Stores/StringsStore";

@observer
export class DownloadButtonListTiny extends ButtonListTiny {

	@computed get classNames() {
		switch (this.props.switchState) {
			case OfflineStatus.None:
				return "type-download-bg-1";
			case OfflineStatus.Waiting:
				return "type-download-bg-4";
			case OfflineStatus.Downloading:
				return "type-download-bg-2 gear";
			case OfflineStatus.Offline:
				return "type-download-bg-3";
			case OfflineStatus.Error:
				return "type-download-bg-5";
			case OfflineStatus.Update:
				return "type-download-bg-6";
			default:
				return "type-download-bg-1";
		}
	}

	@computed get tooltip() {
		switch (this.props.switchState) {
			case OfflineStatus.None:
				return Strings.reader.downloadButtonTooltip;
			case OfflineStatus.Waiting:
				return Strings.reader.downloadButtonWaitingTooltip;
			case OfflineStatus.Downloading:
				return Strings.reader.downloadButtonDownloadingTooltip;
			case OfflineStatus.Offline:
				return Strings.reader.downloadButtonOfflineTooltip;
			case OfflineStatus.Error:
				return Strings.reader.downloadButtonErrorTooltip;
			case OfflineStatus.Update:
				return Strings.reader.downloadButtonUpdateTooltip;
			default:
				return Strings.reader.downloadButtonTooltip;
		}
	}

	render() {
		return <ButtonListTiny {...this.props} title={this.props.title ? this.props.title : this.tooltip}>
			<i className={this.classNames} />
			{
				this.props.switchState === OfflineStatus.Downloading ? <i className="type-download-bg-2cancel" /> : null
			}
		</ButtonListTiny>;
	}
}
